import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

import useWizardFormCtx from './ctx-provider/useWizardFormCtx';
import Progressbar from '../../cmp/Progressbar';
import WizardFormDebugger from '../../cmp/debugger/WizardFormDebugger';
import WizardStepContent from './WizardStepContent';
import useCssMediaQuery from '../../useCssMediaQuery';
import usePageview from '../../usePageview';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {}
    }),
);

const WizardContent: React.FC = () => {
    const classes = useStyles();
    const { wizardFormBo } = useWizardFormCtx();

    const activeStep = wizardFormBo.activeStep;
    const prozentProgress = Math.round((activeStep + 1) * 100 / WizardStepContent.maxStepCount);

    const pageContentType = WizardStepContent.getType(activeStep);
    usePageview(pageContentType.gtmDataLayerValue);

    const cssMediaQuery = useCssMediaQuery();
    const marginTop = cssMediaQuery.desktopVersion ? undefined : pageContentType.marginTopMobile;

    return (
        <>
            <div className={classes.root} style={{ marginTop: marginTop }}>

                <Progressbar prozent={prozentProgress} />

                <div style={{ marginTop: 30 }}>
                    {pageContentType.content}
                </div>

            </div>
            {
                process.env.NODE_ENV === 'production' ? undefined :
                    <div>
                        <WizardFormDebugger />
                    </div>
            }
        </>
    )

}

export default WizardContent;